import ReducerUtils from "../../../utils/ReducerUtils"
import Actions      from "../../../model/constant/actions"


const retrievingIdentityVariants = ReducerUtils.createReducer(false,{
  [Actions.RETRIEVING_IDENTITY_VARIANTS] : (state,action)=>action.status,
})

export default retrievingIdentityVariants
